<div class="card mb-3 orders-card">
  <div class="card-header">
    <div class="row align-items-center justify-content-between">
      <div class="col-md-6">
        <div class="orders-title-row">
          <h5 class="mb-0">Orders</h5>
        </div>
      </div>
      <div class="col-md-6 text-right">
        <input type="text"
               class="form-control form-control-sm order-search"
               placeholder="Search orders..."
               [(ngModel)]="searchText"
               (input)="onSearchChange()" />
      </div>
    </div>
  </div>

  <div class="card-body p-0 orders-table-area">
    <div class="table-responsive orders-table-scroll">
      <table class="table table-sm table-striped table-hover mb-0">
        <thead class="bg-201 text-901 sticky-header">
          <tr>
            <th class="sortable" (click)="sort('OrderCode')">
              Order Code
              <i [class]="getSortIcon('OrderCode')" class="ml-1"></i>
            </th>
            <th class="sortable" (click)="sort('User')">
              User
              <i [class]="getSortIcon('User')" class="ml-1"></i>
            </th>
            <th class="sortable" (click)="sort('Segment')">
              Segment
              <i [class]="getSortIcon('Segment')" class="ml-1"></i>
            </th>
            <th class="sortable" (click)="sort('Approver')">
              Approver
              <i [class]="getSortIcon('Approver')" class="ml-1"></i>
            </th>
            <th class="text-center">Note</th>
            <th class="sortable text-right" (click)="sort('TotalPrice')">
              Total Price
              <i [class]="getSortIcon('TotalPrice')" class="ml-1"></i>
            </th>
            <th class="sortable text-center" (click)="sort('CreateDate')">
              Create Date
              <i [class]="getSortIcon('CreateDate')" class="ml-1"></i>
            </th>
            <th class="sortable text-center" (click)="sort('Status')">
              Status
              <i [class]="getSortIcon('Status')" class="ml-1"></i>
            </th>
            <th class="text-center">Options</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngIf="isOrdersLoading">
            <td colspan="9" class="text-center py-4 text-muted">
              Loading orders...
            </td>
          </tr>

          <tr *ngIf="!isOrdersLoading && pagedOrders.length === 0">
            <td colspan="9" class="text-center py-4 text-muted">
              No orders found for selected filters
            </td>
          </tr>

          <tr *ngFor="let item of pagedOrders; let i = index">
            <td class="align-middle">
              <a href="javascript:void(0)" (click)="openEditPopup(item.Id)">
                <strong>{{ item.OrderCode }}</strong>
              </a>
            </td>
            <td class="align-middle">{{ item.User }}</td>
            <td class="align-middle">{{ item.Segment }}</td>
            <td class="align-middle">{{ item.Approver }}</td>
            <td class="align-middle text-center">
              <button *ngIf="hasOrderNote(item)"
                      type="button"
                      class="btn btn-link btn-sm note-btn"
                      [attr.title]="item.OrderNote"
                      (click)="openNotePopup(item)">
                <i class="fas fa-sticky-note"></i>
              </button>
            </td>
            <td class="align-middle text-right">
              <b>{{ item.TotalPrice | number:'1.2-2' }} <span>₼</span></b>
            </td>
            <td class="align-middle text-center">{{ item.CreateDate }}</td>
            <td class="align-middle text-center">
              <span class="badge badge-pill badge-soft-{{item.StatusCss}} px-3 py-2">
                {{ item.Status }}
              </span>
            </td>
            <td class="align-middle text-center">
              <div class="dropdown">
                <button class="btn btn-link text-600 btn-sm dropdown-toggle btn-reveal"
                        type="button"
                        [id]="'orderDropdown' + i"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false">
                  <span class="fas fa-ellipsis-h"></span>
                </button>

                <div class="dropdown-menu dropdown-menu-right border py-0"
                     [attr.aria-labelledby]="'orderDropdown' + i">
                  <div class="bg-white py-2">
                    <a class="dropdown-item" href="javascript:void(0)" (click)="openEditPopup(item.Id)">
                      <i class="fas fa-edit mr-2 text-primary"></i> Edit
                    </a>

                    <a class="dropdown-item" href="javascript:void(0)" (click)="openHistoryPopup(item)">
                      <i class="fas fa-history mr-2 text-info"></i> History
                    </a>

                    <div class="dropdown-divider" *ngIf="userRole==1"></div>

                    <a *ngIf="userRole==1" class="dropdown-item text-danger" href="javascript:void(0)" (click)="deleteOrder(item)">
                      <i class="fas fa-trash mr-2"></i> Delete
                    </a>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="card-footer d-flex justify-content-between align-items-center flex-wrap">
    <div class="orders-footer-summary mb-2 mb-md-0">
      <span>
        Showing
        <strong>{{ pagedOrders.length }}</strong>
        of
        <strong>{{ totalOrderCount }}</strong>
        orders
      </span>

      <div class="orders-status-strip" *ngIf="statusCounts.length > 0">
        <button type="button"
                class="status-strip-item status-strip-button"
                [class.active]="selectedStatusId === 0"
                (click)="filterByStatus(0)">
          <span class="status-strip-dot"></span>
          <span class="status-strip-label">All</span>
          <strong>{{ getStatusTotalCount() }}</strong>
        </button>

        <button type="button"
                class="status-strip-item status-strip-button"
                *ngFor="let s of statusCounts"
                [class.active]="selectedStatusId === s.statusId"
                [ngClass]="'status-strip-' + s.statusCss"
                (click)="filterByStatus(s.statusId)">
          <span class="status-strip-dot"></span>
          <span class="status-strip-label">{{ s.status }}</span>
          <strong>{{ s.count }}</strong>
        </button>
      </div>
    </div>

    <nav>
      <ul class="pagination pagination-sm mb-0">
        <li class="page-item" [class.disabled]="currentPage === 1">
          <a class="page-link" href="javascript:void(0)" (click)="goToPage(1)">
            First
          </a>
        </li>

        <li class="page-item" [class.disabled]="currentPage === 1">
          <a class="page-link" href="javascript:void(0)" (click)="goToPage(currentPage - 1)">
            <span class="fas fa-chevron-left"></span>
          </a>
        </li>

        <li class="page-item"
            *ngFor="let page of pages"
            [class.active]="page === currentPage">
          <a class="page-link" href="javascript:void(0)" (click)="goToPage(page)">
            {{ page }}
          </a>
        </li>

        <li class="page-item" [class.disabled]="currentPage === totalPages">
          <a class="page-link" href="javascript:void(0)" (click)="goToPage(currentPage + 1)">
            <span class="fas fa-chevron-right"></span>
          </a>
        </li>

        <li class="page-item" [class.disabled]="currentPage === totalPages">
          <a class="page-link" href="javascript:void(0)" (click)="goToPage(totalPages)">
            Last
          </a>
        </li>
      </ul>
    </nav>
  </div>
</div>

<div class="modal fade" id="orderNoteModal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-md modal-dialog-centered" role="document">
    <div class="modal-content border-0 shadow-sm">
      <div class="modal-header">
        <div>
          <h5 class="modal-title mb-0">Order Note</h5>
          <div class="text-muted small">{{ selectedNoteOrderCode }}</div>
        </div>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <div class="order-note-text">
          {{ selectedOrderNote }}
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-sm btn-outline-secondary" type="button" data-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="orderHistoryModal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-md modal-dialog-centered" role="document">
    <div class="modal-content border-0 shadow-sm">
      <div class="modal-header">
        <div>
          <h5 class="modal-title mb-0">Order History</h5>
          <div class="text-muted small">{{ historyOrderCode }}</div>
        </div>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <div *ngIf="isHistoryLoading" class="text-center py-4 text-muted">
          Loading...
        </div>

        <div *ngIf="!isHistoryLoading && historyData.length === 0" class="text-center py-4 text-muted">
          No history found.
        </div>

        <div class="order-timeline" *ngIf="!isHistoryLoading && historyData.length > 0">
          <div class="timeline-item" *ngFor="let h of historyData">
            <div class="timeline-marker" [ngClass]="'timeline-' + h.cssClass">
              <i [class]="getHistoryIcon(h.actionType)"></i>
            </div>

            <div class="timeline-content">
              <div class="timeline-title-row">
                <strong>{{ h.title }}</strong>
                <span>{{ h.actionDate }}</span>
              </div>
              <div class="timeline-actor">{{ h.actor }}</div>
              <div class="timeline-note" *ngIf="h.note">
                {{ h.note }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-sm btn-outline-secondary" type="button" data-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="editOrderModal" tabindex="-1" role="dialog" aria-labelledby="editOrderModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable order-edit-dialog" role="document">
    <div class="modal-content order-edit-modal border-0">

      <div class="card mb-0 border-0">
        <div class="card-header order-edit-header">
          <div class="order-edit-title">
            <span class="text-muted small">Order</span>
            <h5 class="mb-0">{{ orderCode || 'Loading...' }}</h5>
          </div>

            <div class="order-edit-header-actions">
              <span class="badge badge-pill badge-soft-{{ editStatusCss }} px-3 py-2">
                {{ editStatusLabel }}
              </span>
              <button type="button" aria-label="Close" id="X-ModalActivity" data-dismiss="modal" class="close">
                <span aria-hidden="true" class="font-weight-light">×</span>
              </button>
            </div>
        </div>

        <div class="order-edit-summary">
          <div class="summary-item">
            <span>Requested By</span>
            <strong>{{ requestedByName || '-' }}</strong>
          </div>
          <div class="summary-item">
            <span>Items</span>
            <strong>{{ totalItems }}</strong>
          </div>
          <div class="summary-item">
            <span>Quantity</span>
            <strong>{{ totalQty }}</strong>
          </div>
          <div class="summary-item summary-total">
            <span>Total</span>
            <strong>{{ totalPrice | number:'1.2-2' }} AZN</strong>
          </div>
        </div>

        <div class="card-body order-edit-body" *ngIf="!isLoading && orderLineData.length > 0; else editEmptyOrLoading">

          <div class="row order-items-table-header no-gutters px-1 fs--1 font-weight-semi-bold">
            <div class="col-8 col-md-8 py-1 px-2">Name</div>
            <div class="col-4 col-md-4 px-2">
              <div class="row no-gutters">
                <div class="col-md-8 py-1 d-none d-md-block text-center">Quantity</div>
                <div class="col-12 col-md-4 py-1 text-right">Price</div>
              </div>
            </div>
          </div>

          <div class="product-body">
            <div class="row no-gutters align-items-center px-1 border-bottom border-200"
                 *ngFor="let item of orderLineData; trackBy: trackByItem">

              <div class="col-8 col-md-8 py-1 px-2">
                <div class="media align-items-center py-1">
                  <img class="rounded mr-2 d-none d-md-block cursor-pointer order-item-img"
                       [src]="item.img || '../assets/img/products/0.png'"
                       [alt]="item.itemName"
                       width="32"
                       height="32"
                       style="object-fit: cover; cursor:pointer;"
                       (error)="onImageError($event)"
                       (click)="openImagePreview(item.img)">

                  <div class="media-body">
                    <h6 class="mb-0 text-900">{{ item.itemName }}</h6>
                    <div class="fs--2 text-500 mb-0">{{ item.groupName }}</div>
                  </div>
                </div>
              </div>

              <div class="col-4 py-1 px-2">
                <div class="row no-gutters align-items-center">
                  <div class="col-md-8 d-flex justify-content-end justify-content-md-center px-1 mb-1 mb-md-0">
                    <div class="input-group input-group-sm flex-nowrap qty-control"
                         *ngIf="(orderApprover == userId && orderStatus == 1) || userRole==1 || userRole==6">
                      <div class="input-group-prepend">
                        <button class="btn btn-outline-secondary px-2"
                                type="button"
                                (click)="decreaseQty(item)">
                          -
                        </button>
                      </div>

                      <input class="form-control text-center px-1 input-spin-none"
                             type="number"
                             min="1"
                             [(ngModel)]="item.orderQty"
                             (ngModelChange)="onQtyChange(item)"
                             style="max-width: 42px; height: 30px;" />

                      <div class="input-group-append">
                        <button class="btn btn-outline-secondary px-2"
                                type="button"
                                (click)="increaseQty(item)">
                          +
                        </button>
                      </div>
                    </div>

                    <span class="readonly-qty" *ngIf="!((orderApprover == userId && orderStatus == 1) || userRole==1 || userRole==6)">
                      {{item.orderQty}}
                    </span>
                  </div>

                  <div class="col-md-4 d-flex align-items-center justify-content-end text-600 fs--1 pr-1">
                    <span class="mr-2">
                      {{ item.price * item.orderQty | number:'1.2-2' }} ₼
                    </span>

                    <i class="fas fa-trash text-danger remove-icon"
                       *ngIf="(orderApprover == userId && orderStatus == 1) || userRole==1 || userRole==6"
                       title="Remove"
                       style="cursor: pointer;"
                       (click)="removeItem(item.itemCode)">
                    </i>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

        <ng-template #editEmptyOrLoading>
          <div class="card-body order-empty-state">
            <ng-container *ngIf="isLoading; else emptyData">
              <div class="spinner-border spinner-border-sm text-primary mb-3" role="status"></div>
              <h5 class="mb-2">Loading order items...</h5>
              <p class="text-muted mb-0">Please wait while the order details are prepared.</p>
            </ng-container>

            <ng-template #emptyData>
              <i class="fas fa-box-open text-muted mb-3"></i>
              <h5 class="mb-2">No items found</h5>
              <p class="text-muted mb-0">Order has no editable items.</p>
            </ng-template>
          </div>
        </ng-template>

        <div class="order-note-panel">
          <div class="col-12 p-3">
            <label>Customer Note</label>
            <textarea class="form-control"
                      rows="2"
                      placeholder="Write note for this order..."
                      [(ngModel)]="orderDescription">
            </textarea>
          </div>
        </div>

        <div class="card-footer order-action-bar" *ngIf="orderLineData.length > 0">
          <div class="action-left">
            <button class="btn btn-sm btn-outline-info"
                    *ngIf="((orderStatus == 2 || orderStatus == 3) && (userRole == 3)) || ( userRole==1 || userRole==6)"
                    type="button"
                    (click)="printDocument()">
              <i class="fas fa-print mr-1"></i> Print
            </button>
          </div>

          <div class="action-right">
          <button class="btn btn-sm btn-primary"
                  *ngIf="(orderApprover == userId && orderStatus == 1) || userRole==1 || userRole==6"
                  type="button"
                  (click)="operationEditOrder('approve')"
                  [disabled]="isApproving">
            <span *ngIf="!isApproving">Approve</span>
            <span *ngIf="isApproving">Approving...</span>
          </button>

          <button class="btn btn-sm btn-success"
                  *ngIf="((userRole == 3 && orderStatus == 2)) || userRole==1 || userRole==6"
                  type="button"
                  (click)="operationEditOrder('complete')"
                  [disabled]="isReleasing">
            <span *ngIf="!isReleasing">Complete</span>
            <span *ngIf="isReleasing">Completing...</span>
          </button>

          <button class="btn btn-sm btn-outline-danger"
                  *ngIf="(orderApprover == userId && orderStatus == 1) || userRole==1 || userRole==6"
                  type="button"
                  (click)="openDeclineModal()"
                  [disabled]="isDeclining">
            <span *ngIf="!isDeclining">Decline</span>
            <span *ngIf="isDeclining">Declining...</span>
          </button>

          <button class="btn btn-sm btn-outline-secondary border-300"
                  type="button"
                  data-dismiss="modal"
                  [disabled]="isLoading || isApproving || isReleasing || isDeclining">
            Close
          </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<div class="modal fade" id="declineReasonModal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content border-0 shadow-sm">
      <div class="modal-header">
        <h5 class="modal-title">Decline Order</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" [disabled]="isDeclining">
          <span aria-hidden="true">×</span>
        </button>
      </div>

      <div class="modal-body">
        <label class="font-weight-bold mb-2">Decline Reason <span class="text-danger">*</span></label>
        <textarea class="form-control decline-reason-box"
                  rows="4"
                  maxlength="500"
                  placeholder="Write decline reason..."
                  [(ngModel)]="declineReason"
                  [class.is-invalid]="declineReasonTouched && !declineReason.trim()"></textarea>

        <div class="invalid-feedback d-block" *ngIf="declineReasonTouched && !declineReason.trim()">
          Decline reason is required.
        </div>

        <div class="text-right text-muted small mt-2">
          It must be minimum <b>5</b> symbol.
          {{ declineReason.length || 0 }}/500
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-sm btn-outline-secondary"
                type="button"
                data-dismiss="modal"
                [disabled]="isDeclining">
          Cancel
        </button>

        <button class="btn btn-sm btn-danger"
                type="button"
                (click)="confirmDeclineOrder()"
                [disabled]="isDeclining || declineReason.length<5">
          <span *ngIf="!isDeclining">Decline Order</span>
          <span *ngIf="isDeclining">Declining...</span>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="printOrderModal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
    <div class="modal-content border-0">
      <div class="modal-header">
        <h5 class="modal-title">Print Delivery Form</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>

      <div class="modal-body bg-light">
        <div id="printArea" class="print-sheet-wrapper">
          <div class="print-sheet">
            <div class="header">
              <h1>Material Delivery Acknowledgement Form</h1>
              <p>Warehouse Handover / Receiving Confirmation</p>
            </div>

            <table class="meta-table">
              <tr>
                <td class="meta-label">Order No</td>
                <td>{{ orderCode || '-' }}</td>

                <td class="meta-label">Delivery Date</td>
                <td>{{ todayDate }}</td>
                <td class="meta-label">Requested By</td>
                <td>{{ requestedByName || '-' }}</td>
              </tr>
            </table>

            <div class="section-title">Delivered Items</div>

            <table class="items-table">
              <thead>
                <tr>
                  <th class="center" style="width:40px;">No</th>
                  <th>Item Description</th>
                  <th class="center" style="width:80px;">Quantity</th>
                  <th class="center" style="width:80px;">Unit</th>
                  <th class="center" style="width:100px;">Rate</th>
                  <th class="center" style="width:200px;">Remarks</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of orderLineData; let i = index">
                  <td class="center">{{ i + 1 }}</td>
                  <td>{{ item.itemName }}</td>
                  <td class="center">{{ item.orderQty }}</td>
                  <td class="center">{{ item.itemUnit || '-' }}</td>
                  <td class="center">
                    {{ item.price | number:'1.2-2' }}
                    <span>₼</span>
                  </td>
                  <td class="center"></td>
                </tr>
                <tr *ngIf="orderLineData.length === 0">
                  <td colspan="6" class="center">No items found</td>
                </tr>
              </tbody>
            </table>

            <div class="confirmation-text">
              I hereby confirm that I have received the materials/items listed above in the stated quantities and condition.
            </div>
            <table class="signature-grid">
              <tr>
                <td>
                  <div class="signature-card">
                    <div class="signature-title">Handed Over By</div>
                    <div class="sign-line">Name: <span class="line">{{ issuedByName }}</span></div>
                    <div class="sign-line">Signature: <span class="line"></span></div>
                    <div class="sign-line">Date: <span class="line">{{ todayDate }}</span></div>
                  </div>
                </td>
                <td>
                  <div class="signature-card">
                    <div class="signature-title">Received By</div>
                    <div class="sign-line">
                      Name: <span class="line">{{ requestedByName }}</span>
                    </div>
                    <div class="sign-line">Signature: <span class="line"></span></div>
                    <div class="sign-line">Date: <span class="line"></span></div>
                  </div>
                </td>
              </tr>
            </table>

            <div class="footer">
              This document is generated for warehouse delivery confirmation purposes.
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button class="btn btn-primary" (click)="printDocument()">
          <i class="fas fa-print mr-1"></i> Print Form
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="imagePreviewModal" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content bg-transparent border-0">
      <div class="text-right p-2">
        <button class="btn btn-sm btn-light" data-dismiss="modal">✕</button>
      </div>

      <div class="text-center p-2">
        <img [src]="selectedImage"
             class="img-fluid rounded shadow"
             style="max-height: 80vh; object-fit: contain;">
      </div>
    </div>
  </div>
</div>
